import { ApolloClient, InMemoryCache } from '@apollo/client';

const apolloClient = new ApolloClient({
  // eslint-disable-next-line max-len
  uri: 'https://api-eu-central-1.graphcms.com/v2/ckhozbcja00w201xq45xb9m0g/master',
  cache: new InMemoryCache()
});

export default apolloClient;
